export default __webpack_public_path__ + "static/media/left-arrow.35536e53.svg";